"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = exports.UnsupportedMediaTypeError = exports.UnprocessableEntityError = exports.TooManyRequestsError = exports.TimeoutError = exports.SplunkApiError = exports.ServiceUnavailableError = exports.ResourceUnavailableError = exports.RateLimitExceededError = exports.PaymentRequiredError = exports.NotImplementedError = exports.NotFoundError = exports.NetworkError = exports.MethodNotAllowedError = exports.InvalidInputError = exports.InternalServerError = exports.HttpError = exports.GatewayTimeoutError = exports.ForbiddenError = exports.DependencyError = exports.DataIntegrityError = exports.DatabaseError = exports.ConflictError = exports.ConfigurationError = exports.BadRequestError = exports.AuthorizationError = exports.AuthenticationError = exports.CustomError = void 0;
const debuggable_1 = require("@krauters/debuggable");
const logger_1 = require("@krauters/logger");
const os_1 = require("os");
let CustomError = class CustomError extends Error {
    architecture;
    currentWorkingDirectory;
    nodeProcessUptime;
    nodeVersion;
    platform;
    processId;
    userInfo;
    constructor(message, details) {
        super(message);
        this.architecture = (0, os_1.arch)();
        this.currentWorkingDirectory = process.cwd();
        this.name = this.constructor.name;
        this.nodeProcessUptime = `${process.uptime()} seconds`;
        this.nodeVersion = process.version;
        this.platform = process.platform;
        this.processId = process.pid;
        this.userInfo = (0, os_1.userInfo)();
        logger_1.log.error(message, { ...details, errorType: this.name });
    }
    toJson() {
        return JSON.stringify(this.toObject());
    }
    toObject() {
        return {
            architecture: this.architecture,
            currentWorkingDirectory: this.currentWorkingDirectory,
            message: this.message,
            name: this.name,
            nodeProcessUptime: this.nodeProcessUptime,
            nodeVersion: this.nodeVersion,
            platform: this.platform,
            processId: this.processId,
            userInfo: this.userInfo,
        };
    }
};
exports.CustomError = CustomError;
exports.CustomError = CustomError = __decorate([
    (0, debuggable_1.debuggable)(logger_1.log),
    __metadata("design:paramtypes", [String, Object])
], CustomError);
class AuthenticationError extends CustomError {
}
exports.AuthenticationError = AuthenticationError;
class AuthorizationError extends CustomError {
}
exports.AuthorizationError = AuthorizationError;
class BadRequestError extends CustomError {
}
exports.BadRequestError = BadRequestError;
class ConfigurationError extends CustomError {
}
exports.ConfigurationError = ConfigurationError;
class ConflictError extends CustomError {
}
exports.ConflictError = ConflictError;
class DatabaseError extends CustomError {
}
exports.DatabaseError = DatabaseError;
class DataIntegrityError extends CustomError {
}
exports.DataIntegrityError = DataIntegrityError;
class DependencyError extends CustomError {
}
exports.DependencyError = DependencyError;
class ForbiddenError extends CustomError {
}
exports.ForbiddenError = ForbiddenError;
class GatewayTimeoutError extends CustomError {
}
exports.GatewayTimeoutError = GatewayTimeoutError;
class HttpError extends CustomError {
}
exports.HttpError = HttpError;
class InternalServerError extends CustomError {
}
exports.InternalServerError = InternalServerError;
class InvalidInputError extends CustomError {
}
exports.InvalidInputError = InvalidInputError;
class MethodNotAllowedError extends CustomError {
}
exports.MethodNotAllowedError = MethodNotAllowedError;
class NetworkError extends CustomError {
}
exports.NetworkError = NetworkError;
class NotFoundError extends CustomError {
}
exports.NotFoundError = NotFoundError;
class NotImplementedError extends CustomError {
}
exports.NotImplementedError = NotImplementedError;
class PaymentRequiredError extends CustomError {
}
exports.PaymentRequiredError = PaymentRequiredError;
class RateLimitExceededError extends CustomError {
}
exports.RateLimitExceededError = RateLimitExceededError;
class ResourceUnavailableError extends CustomError {
}
exports.ResourceUnavailableError = ResourceUnavailableError;
class ServiceUnavailableError extends CustomError {
}
exports.ServiceUnavailableError = ServiceUnavailableError;
class SplunkApiError extends CustomError {
}
exports.SplunkApiError = SplunkApiError;
class TimeoutError extends CustomError {
}
exports.TimeoutError = TimeoutError;
class TooManyRequestsError extends CustomError {
}
exports.TooManyRequestsError = TooManyRequestsError;
class UnprocessableEntityError extends CustomError {
}
exports.UnprocessableEntityError = UnprocessableEntityError;
class UnsupportedMediaTypeError extends CustomError {
}
exports.UnsupportedMediaTypeError = UnsupportedMediaTypeError;
class ValidationError extends CustomError {
}
exports.ValidationError = ValidationError;
//# sourceMappingURL=errors.js.map